import { Component, DoCheck, OnInit } from '@angular/core';
import { MensagemService, ProgressoService, Restricoes } from 'maestro-ng';
import { FonteDados } from '../fonte-dados.model';
import { FonteDadosService } from '../fonte-dados.service';
import { MonitoramentoCacheService } from '../monitoramento-cache.service';
import { Monitoramento } from '../monitoramento.model';
import { ConversorMonitoramento } from './../../monitoramento/conversor-monitoramento.model';
import { ExtratorMonitoramento } from './../../monitoramento/extrator-monitoramento.model';
import { IrisMonitoramento } from './../../monitoramento/iris-monitoramento.model';
import { PrismaMonitoramento } from './../../monitoramento/prisma-monitoramento.model';
import { DataSourceRouted } from '../../util/data-source-routed';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-fonte-dados-monitor',
  templateUrl: './fonte-dados-monitor.component.html',
  styleUrls: ['./fonte-dados-monitor.component.css'],
})
export class FonteDadosMonitorComponent implements OnInit, DoCheck {
  readonly orgaoJusticaGeral = {
    id: Number.NEGATIVE_INFINITY,
    nome: 'Nacional',
    sigla: null,
    segmento: null,
    situacao: null,
    numeracaoUnicaIdentificador: null,
  };

  ds: DataSourceRouted<FonteDados, number>;
  lastLoadEvent: any;
  firstRowInPage: number;
  rowGroupMetadata: any;
  monitoramentos: any;

  constructor(
    private service: FonteDadosService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private monitorCacheService: MonitoramentoCacheService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<FonteDados, number>(
      'fonte-dados-monitor',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([])
    );
    this.lastLoadEvent = undefined;
    this.firstRowInPage = 0;
    this.monitoramentos = {};
  }

  ngOnInit(): void {}

  ngDoCheck() {
    if (this.lastLoadEvent !== this.ds.ultimoCarregamentoEvento) {
      this.lastLoadEvent = this.ds.ultimoCarregamentoEvento;
      this.firstRowInPage = this.ds.ultimoCarregamentoEvento.first;
      this.adicionarOrgaosJusticaFaltantes();
      this.updateRowGroupMetaData();
      this.monitorarTudo();
    }
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};

    for (let i = 0; i < this.ds.entidades.length; i++) {
      const rowData = this.ds.entidades[i];
      const nomeOrgaoJustica = rowData.extrator.orgaoJustica.nome;

      if (i === 0) {
        this.rowGroupMetadata[nomeOrgaoJustica] = { index: 0, size: 1 };
      } else {
        const previousRowData = this.ds.entidades[i - 1];
        const previousRowGroup = previousRowData.extrator.orgaoJustica.nome;
        if (nomeOrgaoJustica === previousRowGroup) {
          this.rowGroupMetadata[nomeOrgaoJustica].size++;
        } else {
          this.rowGroupMetadata[nomeOrgaoJustica] = { index: i, size: 1 };
        }
      }
    }
  }

  adicionarOrgaosJusticaFaltantes() {
    this.ds.entidades.forEach((element) => {
      if (!element.extrator.orgaoJustica) {
        // element.extrator.orgaoJustica = this.orgaoJusticaGeral;
      }
    });
  }

  limparCacheEMonitorarTudo() {
    this.monitorarTudo(true);
  }

  monitorarTudo(limparCache: boolean = false) {
    this.ds.entidades.forEach((fonteDados) => {
      this.monitorarFonteDados(fonteDados, limparCache);
    });
  }

  monitorarFonteDados(fonteDados: FonteDados, limparCache: boolean = false) {
    this.monitoramentos[fonteDados.id] = new Monitoramento();
    this.monitoramentos[fonteDados.id].conversor.carregando = true;
    this.monitoramentos[fonteDados.id].extrator.carregando = true;
    this.monitoramentos[fonteDados.id].iris.carregando = true;
    this.monitoramentos[fonteDados.id].prisma.carregando = true;

    this.monitorCacheService.getConversor(fonteDados, limparCache).subscribe(
      (monitoramento) => {
        this.monitoramentos[fonteDados.id].conversor.atualizar(monitoramento, ConversorMonitoramento.getAtivos(monitoramento));
      },
      (error) => {
        this.monitoramentos[fonteDados.id].conversor.atualizarComErro(error.error);
      }
    );

    this.monitorCacheService.getExtrator(fonteDados, limparCache).subscribe(
      (monitoramento) => {
        this.monitoramentos[fonteDados.id].extrator.atualizar(monitoramento, ExtratorMonitoramento.getAtivos(monitoramento));
      },
      (error) => {
        this.monitoramentos[fonteDados.id].extrator.atualizarComErro(error.error);
      }
    );

    this.monitorCacheService.getPrisma(fonteDados, limparCache).subscribe(
      (monitoramento) => {
        this.monitoramentos[fonteDados.id].prisma.atualizar(monitoramento, PrismaMonitoramento.getAtivos(monitoramento));
      },
      (error) => {
        this.monitoramentos[fonteDados.id].prisma.atualizarComErro(error.error);
      }
    );

    this.monitorCacheService.getIris(fonteDados, limparCache).subscribe(
      (monitoramento) => {
        this.monitoramentos[fonteDados.id].iris.atualizar(monitoramento, IrisMonitoramento.getAtivos(monitoramento));
      },
      (error) => {
        this.monitoramentos[fonteDados.id].iris.atualizarComErro(error.error);
      }
    );
  }
}
